import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../../theme/style-helpers';
import PlusIcon from '../../../../assets/icons/plus_circular_icon_orange.svg';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
    padding-top: 32px;
    padding-bottom: 40px;
`;

export const PageHeader = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
    ${MediaQuery.xLarge(css`
        grid-auto-flow: column;
        grid-template-columns: 762px auto;
        align-items: end;
    `)};
`;

export const TitleContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;    
`;

export const Title = styled.h2`
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const PageDescription = styled.div`
    white-space: pre-wrap;
    > span {
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0.01em;
        color: ${colors.BLACK};
        margin: 0;
        display: inline;
    }
`;

export const ToggleContainer = styled.div`
    justify-self: end;
`;

export const ItemsContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
`;

export const AddItemButton = styled.button`
    display: flex;
    border: 1px solid #d9d9d6;
    border-radius: 4px;
    padding: 24px;
    padding-left: 64px;
    background-color: ${colors.WHITE};
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: #63666A;
    background-image: url(${PlusIcon});
    background-repeat: no-repeat;
    background-position: 32px;
    cursor: pointer;
`;

export const SummaryContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 12px;
    ${MediaQuery.medium(css`
        grid-auto-flow: column;
        column-gap: 24px;
        grid-template-columns: repeat(2, 250px);
        justify-content: center;
    `)};
`;

export const Summary = styled.div`
    display: flex;
    padding: 12px;
    background-color: #FFEFE8;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
`;

export const SummaryLabel = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
    padding-right: 8px;
`;

export const SummaryValue = styled.p`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
`;

export const AdditionalInformationContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
`;

export const AdditionalInformationFields = styled.div`
    padding: 24px 20px;
    background-color: #F9F9F9;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    ${MediaQuery.medium(css`
        padding: 32px;
    `)};
`;

export const AdditionalInformationRow1 = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    grid-row: 2;
    ${MediaQuery.medium(css`
        grid-auto-flow: column;
        grid-template-columns: repeat(2, 264px);
        column-gap: 24px;
        grid-row: 1;
    `)};
`;

export const AdditionalInformationRow2 = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    grid-row: 1;

    ${MediaQuery.medium(css`
        grid-auto-flow: column;
        grid-template-columns: repeat(3, 235px);
        column-gap: 24px;
        grid-row: 2;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(3, 264px);
    `)};
`;

export const AdditionalInformationRow3 = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;

    ${MediaQuery.medium(css`
        grid-auto-flow: column;
        grid-template-columns: repeat(2, 264px);
        column-gap: 24px;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(4, 264px);
    `)};
`;
